// src/pages/ReportIssue.js
import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button, Alert } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase'; // Import your Firebase functions

const ReportIssue = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [issueDescription, setIssueDescription] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');

    const sendEmail = httpsCallable(functions, 'sendNotificationEmail');

    const subject = 'Issue Report';
    const text = `Name: ${name}\nEmail: ${email}\nIssue Description: ${issueDescription}`;

    try {
      await sendEmail({ to: 'bcaspersz@gmail.com', subject, text });
      setSuccess('Issue reported successfully!');
      setName('');
      setEmail('');
      setIssueDescription('');
    } catch (error) {
      console.error('Error reporting issue:', error.message);
      setError('Failed to report issue. Please try again.');
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" gutterBottom>
          Report an Issue
        </Typography>
        {success && <Alert severity="success">{success}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          onSubmit={handleSubmit}
        >
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Issue Description"
            variant="outlined"
            fullWidth
            required
            multiline
            rows={4}
            value={issueDescription}
            onChange={(e) => setIssueDescription(e.target.value)}
          />
          <Button variant="contained" color="primary" type="submit">
            Report Issue
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ReportIssue;
